import { featureColumns } from "@/mocks/news";

const steps = [
  {
    icon: "ri-inbox-archive-line",
    title: "收到线索",
    text: "先记录来源、时间与原始描述，不做情绪化改写。",
  },
  {
    icon: "ri-link-m",
    title: "交叉核对",
    text: "至少找到两个可以互相印证的细节，才进入待发状态。",
  },
  {
    icon: "ri-git-commit-line",
    title: "排成时间线",
    text: "把首发、回应与反转串成一条线，方便你从头看。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续补充",
    text: "后续变化写回同一条目，旧内容不做无声修改。",
  },
];

export default function ColumnsSection() {
  return (
    <section id="columns" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-secondary-700">
              <i className="ri-book-open-line" aria-hidden />
              专题解读
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              把零散的瓜，整理成能看懂的东西
            </h2>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {featureColumns.map((column) => (
            <article
              key={column.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={column.cover}
                  alt={`${column.title} 专题配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded-md bg-secondary-500 px-2.5 py-1 text-[11px] font-medium text-secondary-950">
                  {column.kicker}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                  {column.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{column.excerpt}</p>
                <div className="mt-auto flex items-center justify-between pt-5 text-xs text-foreground-500">
                  <span>{column.meta}</span>
                  <a
                    href="#latest"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
                  >
                    阅读专题
                    <i className="ri-arrow-right-line" aria-hidden />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12">
          <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
            <i className="ri-route-line text-primary-600" aria-hidden />
            一条爆料在发布前会经过什么
          </h3>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => (
              <div
                key={step.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-200 text-accent-700">
                    <i className={`${step.icon} text-lg`} aria-hidden />
                  </span>
                  <span className="font-heading text-2xl font-black text-background-400">
                    0{index + 1}
                  </span>
                </div>
                <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {step.title}
                </h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}